<template>
    <div v-if="candidate">
    <div class="d-flex justify-content-center container text-start mt-3">
        <div class="card" style="width: 500px">
            <div class="card-header">
                <b style="font-size: 20px">APPRAISAL RESULT</b>
            </div>
            <div class="ms-4 mt-3">
                <p>Name: {{ candidate.name }}</p>
                <p>File No.: {{ candidate.fileNum }}</p>
            </div>
            <div class="p-1">
                <table class="table table-striped">
                    <tbody>
                        <tr>
                            <th></th>
                            <th>ITEM</th>
                            <th>SCORE</th>
                        </tr>
                        <tr v-if="certifierIsAssessor || certifierIsInternal || certifierIsPanel">
                            <th></th>
                            <td>Qualifications</td>
                            <td>
                                <div>
                                    {{ qualificationScore }}
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <th></th>
                            <td>Publications and Other Productive Works</td>
                            <td>
                                <div>
                                    {{ candidate.staffType == 'Library' ? (publicationsScore - workSum) : publicationsScore }}
                                </div>
                            </td>
                        </tr>
                        <tr v-if="candidate.staffType == 'Library' && certifierIsAssessor || certifierIsInternal || certifierIsPanel">
                            <th></th>
                            <td>Non-published Productive Works</td>
                            <td>
                                <div>
                                    {{ workSum }}
                                </div>
                            </td>
                        </tr>
                        <tr v-if="certifierIsAssessor || certifierIsInternal || certifierIsPanel">
                            <th></th>
                            <td>
                                <span v-if="candidate.staffType == 'Academic Teaching'">Teaching and </span>
                                <span v-if="candidate.staffType == 'Research'">Research Experience and Innovation and </span>
                                Professional Experience
                            </td>
                            <td>
                                <div>
                                    {{ teachingScore }}
                                </div>
                            </td>
                        </tr>
                        <tr v-if="candidate.staffType != 'Library' && certifierIsAssessor || certifierIsInternal || certifierIsPanel">
                            <th></th>
                            <td>Academic Leadership</td>
                            <td>
                                <div>
                                    {{ academicLeadershipScore }}
                                </div>
                            </td>
                        </tr>
                        <tr v-if="certifierIsAssessor || certifierIsInternal || certifierIsPanel">
                            <th></th>
                            <td>Conferences and Learned Society Activities</td>
                            <td>
                                <div>
                                    {{ conferenceScore }}
                                </div>
                            </td>
                        </tr>
                        <tr v-if="certifierIsAssessor || certifierIsInternal || certifierIsPanel">
                            <th></th>
                            <td>University Administration</td>
                            <td>
                                <div>
                                    {{ uniAdminScore }}
                                </div>
                            </td>
                        </tr>
                        <tr v-if="certifierIsAssessor || certifierIsInternal || certifierIsPanel">
                            <th></th>
                            <td>Community Service</td>
                            <td>
                                <div>
                                    {{ communityServiceScore }}
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <th></th>
                            <td>Bonus</td>
                            <td>
                                <div>
                                    {{ candidate.bonus }}
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <th></th>
                            <th class="text-end">TOTAL</th>
                            <th>
                                <div>
                                    {{ total }}
                                </div>
                            </th>
                        </tr>
                    </tbody>
                </table>
                <div v-if="certifierIsAssessor || certifierIsExternal || certifierIsInternal">
                    <div class="m-4">
                        <div>
                            <p><b>General comments:</b></p>
                        </div>
                        <div style="margin-top: -20px;">
                            <textarea v-model="comments" type="text" class="form-control" rows="5"></textarea>
                        </div>
                    </div>
                    <div class="m-4">
                        <p>
                            <b>Do you approve the candidate for promotion?</b>
                        </p>
                        <div class="form-check">
                            <input class="form-check-input" type="radio" name="radioDefault" id="radioDefault1" v-model="approval" :value=true>
                            <label class="form-check-label" for="radioDefault1">
                                Yes, I approve the candidate for promotion.
                            </label>
                        </div>
                        <div class="form-check">
                            <input class="form-check-input" type="radio" name="radioDefault" id="radioDefault2" v-model="approval" :value=false>
                            <label class="form-check-label" for="radioDefault2">
                                No, I do not approve the candidate for promotion.
                            </label>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    
    <div v-if="certifierIsExternal" class="d-flex justify-content-center container mt-4 mb-3">
        <div class="card" style="width: 500px;" hidden>
            <div class="m-4">
                <h5 style="color: darkgreen;">
                    <b>ASSESSOR BANK ACCOUNT DETAILS</b>
                </h5>
                <div>
                    <p class="mb-0 mt-4"><b>Bank:</b></p>
                </div>
                <div>
                    <input type="text" class="form-control pb-0" name="bank" v-model="bank">
                </div>
                <div>
                    <p class="mb-0 mt-2"><b>Account Name:</b></p>
                </div>
                <div>
                    <input type="text" class="form-control pb-0" name="acctName" v-model="acctName">
                </div>
                <div>
                    <p class="mb-0 mt-2"><b>Account Number:</b></p>
                </div>
                <div>
                    <input type="number" class="form-control mb-3" name="acctNum" v-model="acctNum">
                </div>
            </div>
        </div>
    </div>

    <div class="d-flex justify-content-center mb-5">
        <div class="my-3 ms-3">
            <router-link :to="'/candidate/' + candidate._id + '?token=' + $route.query.token">
                <button type="button" class="btn btn-success">Back to Scoring</button>
            </router-link>
        </div>
        &nbsp;&nbsp;
        <div class="my-3 me-3" v-if="certifierIsAssessor || certifierIsExternal || certifierIsInternal">
            <button @click="submitAssessment()" type="button" class="btn btn-success">Submit Assessment</button>
        </div>
    </div>
    </div>
</template>
<script>
import DataService from '../../services/dataservice';

export default {
    name: 'result',
    emits: ['toggleLoader', 'setSection'],
    data() {
        return {
            candidate: {
                academicStaff: {
                    books: [],
                    majorWorks: [],
                    minorWorks: [],
                    bookChapters: [],
                    journalArticles: [],
                    conferenceArticles: [],
                    technicalReports: [],
                    bookEditors: [],
                    otherBooks: [],
                    sessionsTaught: 0,
                    teachingScore: 0,
                    pgTeachings: [],
                    ugTeachings: [],
                    professionalExperiences: [],
                    degreePrograms: [],
                    seminarWorkshops: [],
                    pgSupervisions: [],
                    ugSupervisions: [],
                    conferences: [],
                    universityAdmins: [],
                    otherServices: [],
                },
                communityServices: [],
                professionalBodies: [],
                committeeMemberships: [],
                staffType: '',
                bonus: 0
            },
            comments: '',
            approval: false,
            bank: '',
            acctName: '',
            acctNum: ''
        }
    },
    created() {
        this.setData()
    },
    computed: {
        certifierIsAssessor() {
            if (this.$route.query.token && this.$route.query.token != 'undefined') {
                var payload = this.$route.query.token.split('.')[1]
                return JSON.parse(atob(payload)).certifier == 'assessor'
            } else {
                return false
            }
        },
        certifierIsPanel() {
            if (this.$route.query.token && this.$route.query.token != 'undefined') {
                var payload = this.$route.query.token.split('.')[1]
                return JSON.parse(atob(payload)).certifier == 'panel'
            } else {
                return false
            }
        },
        certifierIsExternal() {
            if (this.$route.query.token && this.$route.query.token != 'undefined') {
                var payload = this.$route.query.token.split('.')[1]
                return JSON.parse(atob(payload)).certifier == 'external'
            } else {
                return false
            }
        },
        certifierIsInternal() {
            if (this.$route.query.token && this.$route.query.token != 'undefined') {
                var payload = this.$route.query.token.split('.')[1]
                return JSON.parse(atob(payload)).certifier == 'internal'
            } else {
                return false
            }
        },
        qualificationScore() {
            if (this.candidate.doctorate && this.candidate.masters) {
                var qualificationTotal = this.candidate.doctorate.score + this.candidate.masters.score

                if ((this.candidate.presentStatus == 'Assistant Lecturer' || this.candidate.presentStatus == 'Assistant Research Fellow' || this.candidate.presentStatus == 'Assistant Librarian') && qualificationTotal > 60) {
                    qualificationTotal = 60
                } else if ((this.candidate.presentStatus == 'Lecturer II' || this.candidate.presentStatus == 'Research Fellow II' || this.candidate.presentStatus == 'Librarian II') && qualificationTotal > 30) {
                    qualificationTotal = 30
                } else if ((this.candidate.presentStatus == 'Lecturer I' || this.candidate.presentStatus == 'Research Fellow I' || this.candidate.presentStatus == 'Librarian I') && qualificationTotal > 10) {
                    qualificationTotal = 10
                } else if ((this.candidate.presentStatus == 'Senior Lecturer' || this.candidate.presentStatus == 'Senior Research Fellow' || this.candidate.presentStatus == 'Senior Librarian') && qualificationTotal > 5) {
                    qualificationTotal = 5
                } else if ((this.candidate.presentStatus == 'Reader' || this.candidate.presentStatus == 'Research Reader' || this.candidate.presentStatus == 'Principal Librarian' || this.candidate.presentStatus == 'Deputy Librarian') && qualificationTotal > 5) {
                    qualificationTotal = 5
                }

                return qualificationTotal
            }

            return 0
        },
        workSum(){
            var workSum = 0
            workSum = this.sumArray(this.candidate.academicStaff.majorWorks, workSum) + this.sumArray(this.candidate.academicStaff.minorWorks, workSum);

            if (this.candidate.staffType != 'Library') {
                return workSum > 4 ? 4 : workSum;
            } else {
                if (this.candidate.presentStatus == 'Assistant Librarian') {
                    workSum = workSum > 5 ? 5 : workSum
                } else if (this.candidate.presentStatus == 'Librarian II') {
                    workSum = workSum > 5 ? 5 : workSum
                } else if (this.candidate.presentStatus == 'Librarian I') {
                    workSum = workSum > 15 ? 15 : workSum
                } else if (this.candidate.presentStatus == 'Senior Librarian') {
                    workSum = workSum > 10 ? 10 : workSum
                } else if (this.candidate.presentStatus == 'Principal Librarian') {
                    workSum = workSum > 15 ? 15 : workSum
                } else if (this.candidate.presentStatus == 'Deputy Librarian') {
                    workSum = workSum > 10 ? 10 : workSum
                }

                return workSum
            }
        },
        publicationsScore() {
            var [
                publicationSum,
                bookSum,
                otherBookSum,
                bookChapterSum,
                journalArticleSum,
                conferenceArticleSum,
                technicalReportSum,
                bookEditorSum
            ] = Array(9).fill(0);

            bookSum = this.sumArray(this.candidate.academicStaff.books, bookSum) + this.sumArray(this.candidate.academicStaff.otherBooks, otherBookSum);
            bookSum = bookSum > 6 ? 6 : bookSum;

            bookChapterSum = this.sumArray(this.candidate.academicStaff.bookChapters, bookChapterSum);
            bookChapterSum = bookChapterSum > 4 ? 4 : bookChapterSum

            journalArticleSum = this.sumArray(this.candidate.academicStaff.journalArticles, journalArticleSum);

            conferenceArticleSum = this.sumArray(this.candidate.academicStaff.conferenceArticles, conferenceArticleSum)
            conferenceArticleSum = conferenceArticleSum > 4 ? 4 : conferenceArticleSum;

            technicalReportSum = this.sumArray(this.candidate.academicStaff.technicalReports, technicalReportSum);
            technicalReportSum = technicalReportSum > 4 ? 4 : technicalReportSum;

            bookEditorSum = this.sumArray(this.candidate.academicStaff.bookEditors, bookEditorSum);
            bookEditorSum = bookEditorSum > 2 ? 2 : bookEditorSum;

            publicationSum = bookSum + this.workSum + bookChapterSum + journalArticleSum + conferenceArticleSum + technicalReportSum + bookEditorSum;

            publicationSum = this.candidate.staffType == 'Library' ? (publicationSum - this.workSum) : publicationSum

            if (this.candidate.presentStatus == 'Assistant Lecturer' || this.candidate.presentStatus == 'Assistant Research Fellow') {
                publicationSum = publicationSum > 10 ? 10 : publicationSum
            } else if (this.candidate.presentStatus == 'Lecturer II' || this.candidate.presentStatus == 'Research Fellow II' || this.candidate.presentStatus == 'Librarian II') {
                publicationSum = this.candidate.presentStatus == 'Librarian II' ? (publicationSum > 5 ? 5 : publicationSum) : (publicationSum > 25 ? 25 : publicationSum)
            } else if (this.candidate.presentStatus == 'Lecturer I' || this.candidate.presentStatus == 'Research Fellow I' || this.candidate.presentStatus == 'Librarian I') {
                publicationSum = this.candidate.presentStatus == 'Librarian I' ? (publicationSum > 10 ? 10 : publicationSum) :  (publicationSum > 30 ? 30 : publicationSum)
            } else if (this.candidate.presentStatus == 'Senior Lecturer' || this.candidate.presentStatus == 'Senior Research Fellow' || this.candidate.presentStatus == 'Senior Librarian') {
                publicationSum = this.candidate.presentStatus == 'Senior Librarian' ? (publicationSum > 20 ? 20 : publicationSum) : (publicationSum > 55 ? 55 : publicationSum)
            } else if (this.candidate.presentStatus == 'Reader' || this.candidate.presentStatus == 'Research Reader') {
                publicationSum = publicationSum > 60 ? 60 : publicationSum
            } else if (this.candidate.presentStatus == 'Principal Librarian') {
                publicationSum = publicationSum > 45 ? 45 : publicationSum
            } else if (this.candidate.presentStatus == 'Deputy Librarian') {
                publicationSum = publicationSum > 50 ? 50 : publicationSum
            }

            return publicationSum
        },
        teachingScore() {

            var teachingSum = 0;

            teachingSum = this.candidate.academicStaff.sessionsTaught * this.candidate.academicStaff.teachingScore;

            if (this.candidate.presentStatus == 'Assistant Lecturer' || this.candidate.presentStatus == 'Assistant Research Fellow') {
                teachingSum = teachingSum > 15 ? 15 : teachingSum
            } else if (this.candidate.presentStatus == 'Lecturer II' || this.candidate.presentStatus == 'Research Fellow II') {
                teachingSum = teachingSum > 30 ? 30 : teachingSum
            } else if (this.candidate.presentStatus == 'Lecturer I' || this.candidate.presentStatus == 'Research Fellow I') {
                teachingSum = teachingSum > 40 ? 40 : teachingSum
            } else if (this.candidate.presentStatus == 'Senior Lecturer' || this.candidate.presentStatus == 'Senior Research Fellow') {
                teachingSum = teachingSum > 20 ? 20 : teachingSum
            } else if (this.candidate.presentStatus == 'Reader'|| this.candidate.presentStatus == 'Research Reader') {
                teachingSum = teachingSum > 15 ? 15 : teachingSum
            } else if (this.candidate.presentStatus == 'Assistant Librarian') {
                teachingSum = teachingSum > 10 ? 10 : teachingSum
            } else if (this.candidate.presentStatus == 'Librarian II') {
                teachingSum = teachingSum > 15 ? 15 : teachingSum
            } else if (this.candidate.presentStatus == 'Librarian I') {
                teachingSum = teachingSum > 30 ? 30 : teachingSum
            } else if (this.candidate.presentStatus == 'Senior Librarian') {
                teachingSum = teachingSum > 35 ? 35 : teachingSum
            } else if (this.candidate.presentStatus == 'Principal Librarian') {
                teachingSum = teachingSum > 15 ? 15 : teachingSum
            } else if (this.candidate.presentStatus == 'Deputy Librarian') {
                teachingSum = teachingSum > 15 ? 15 : teachingSum
            }

            return teachingSum
        },
        academicLeadershipScore() {
            var [
                leadershipSum,
                pgSupervisionSum,
                ugSupervisionSum
            ] = Array(3).fill(0);

            pgSupervisionSum = this.sumArray(this.candidate.academicStaff.pgSupervisions, pgSupervisionSum);
            pgSupervisionSum = pgSupervisionSum > 4 ? 4 : pgSupervisionSum;

            ugSupervisionSum = this.sumArray(this.candidate.academicStaff.ugSupervisions, ugSupervisionSum);
            ugSupervisionSum = ugSupervisionSum > 4 ? 4 : ugSupervisionSum;

            leadershipSum = pgSupervisionSum + ugSupervisionSum;

            if (this.candidate.presentStatus == 'Assistant Lecturer') {
                leadershipSum = 0
            } else if (this.candidate.presentStatus == 'Lecturer II') {
                leadershipSum = 0
            } else if (this.candidate.presentStatus == 'Lecturer I') {
                leadershipSum = 0
            } else if (this.candidate.presentStatus == 'Senior Lecturer' || this.candidate.presentStatus == 'Senior Research Fellow') {
                leadershipSum = leadershipSum > 5 ? 5 : leadershipSum
            } else if (this.candidate.presentStatus == 'Reader' || this.candidate.presentStatus == 'Research Reader') {
                leadershipSum = leadershipSum > 10 ? 10 : leadershipSum
            }

            return leadershipSum
        },
        conferenceScore() {
            var [conferenceProfessionalSum, conferenceSum, professionalBodySum] = [0, 0, 0]

            conferenceSum = this.sumArray(this.candidate.academicStaff.conferences, conferenceSum);
            conferenceSum = conferenceSum > 3 ? 3 : conferenceSum;

            professionalBodySum = this.sumArray(this.candidate.professionalBodies, professionalBodySum);
            professionalBodySum = professionalBodySum > 3 ? 3 : professionalBodySum;

            conferenceProfessionalSum = conferenceSum + professionalBodySum;

            if (
                this.candidate.presentStatus == 'Assistant Lecturer' || this.candidate.presentStatus == 'Assistant Research Fellow' ||
                this.candidate.presentStatus == 'Lecturer II' || this.candidate.presentStatus == 'Research Fellow II' ||
                this.candidate.presentStatus == 'Lecturer I' || this.candidate.presentStatus == 'Research Fellow I' ||
                this.candidate.presentStatus == 'Senior Lecturer' || this.candidate.presentStatus == 'Senior Research Fellow' ||
                this.candidate.presentStatus == 'Assistant Librarian' || this.candidate.presentStatus == 'Librarian II' ||
                this.candidate.presentStatus == 'Librarian I' || this.candidate.presentStatus == 'Senior Librarian' ||
                this.candidate.presentStatus == 'Principal Librarian' || this.candidate.presentStatus == 'Deputy Librarian'
            ) {
                conferenceProfessionalSum = conferenceProfessionalSum > 5 ? 5 : conferenceProfessionalSum
            } else if (this.candidate.presentStatus == 'Reader' || this.candidate.presentStatus == 'Research Reader') {
                conferenceProfessionalSum = conferenceProfessionalSum > 3 ? 3 : conferenceProfessionalSum
            }

            return conferenceProfessionalSum
        },
        uniAdminScore() {
            var [uniAdminTotal, uniAdminSum, committeeMemberSum, otherSum] = Array(4).fill(0);

            uniAdminSum = this.multiplyArray(this.candidate.academicStaff.universityAdmins, uniAdminSum);
            uniAdminSum = uniAdminSum > 10 ? 10 : uniAdminSum;

            committeeMemberSum = this.multiplyArray(this.candidate.committeeMemberships, committeeMemberSum);
            committeeMemberSum = committeeMemberSum > 2 ? 2 : committeeMemberSum;

            otherSum = this.multiplyArray(this.candidate.academicStaff.otherServices, otherSum);
            otherSum = otherSum > 2 ? 2 : otherSum;

            uniAdminTotal = uniAdminSum + committeeMemberSum + otherSum;

            if (this.candidate.staffType != 'Library') {
                if (this.candidate.presentStatus == 'Senior Research Fellow') {
                    uniAdminTotal = uniAdminTotal > 8 ? 8 : uniAdminTotal
                } else {
                    uniAdminTotal = uniAdminTotal > 5 ? 5 : uniAdminTotal
                }
            } else {
                if (this.candidate.presentStatus == 'Assistant Librarian' || this.candidate.presentStatus == 'Librarian II' || this.candidate.presentStatus == 'Librarian I') {
                    uniAdminTotal = uniAdminTotal > 5 ? 5 : uniAdminTotal
                } else if (this.candidate.presentStatus == 'Senior Librarian' || this.candidate.presentStatus == 'Principal Librarian' || this.candidate.presentStatus == 'Deputy Librarian') {
                    uniAdminTotal = uniAdminTotal > 10 ? 10 : uniAdminTotal
                }
            }

            return uniAdminTotal
        },
        communityServiceScore() {
            var communityServiceSum = 0;

            communityServiceSum = this.multiplyArray(this.candidate.communityServices, communityServiceSum);
            communityServiceSum = communityServiceSum > 6 ? 6 : communityServiceSum;

            if (
                this.candidate.presentStatus == 'Assistant Lecturer' || this.candidate.presentStatus == 'Assistant Research Fellow' ||
                this.candidate.presentStatus == 'Lecturer II' || this.candidate.presentStatus == 'Research Fellow II' ||
                this.candidate.presentStatus == 'Lecturer I' || this.candidate.presentStatus == 'Research Fellow I' ||
                this.candidate.presentStatus == 'Senior Lecturer' || this.candidate.presentStatus == 'Senior Research Fellow' ||
                this.candidate.presentStatus == 'Assistant Librarian' || this.candidate.presentStatus == 'Librarian II' ||
                this.candidate.presentStatus == 'Librarian I' || this.candidate.presentStatus == 'Senior Librarian' ||
                this.candidate.presentStatus == 'Principal Librarian' || this.candidate.presentStatus == 'Deputy Librarian'
            ) {
                communityServiceSum = communityServiceSum > 5 ? 5 : communityServiceSum
            } else if (this.candidate.presentStatus == 'Reader' || this.candidate.presentStatus == 'Research Reader') {
                communityServiceSum = communityServiceSum > 2 ? 2 : communityServiceSum
            }

            return communityServiceSum

        },
        total() {
            var total = 0;

            if (this.candidate.staffType == 'Library') {
                total = this.qualificationScore + this.publicationsScore + this.workSum + this.teachingScore + this.conferenceScore + this.uniAdminScore + this.communityServiceScore + (this.candidate.bonus ? this.candidate.bonus : 0);
            } else {
                total = this.qualificationScore + this.publicationsScore + this.teachingScore + this.academicLeadershipScore + this.conferenceScore + this.uniAdminScore + this.communityServiceScore + (this.candidate.bonus ? this.candidate.bonus : 0);
            }

            return total;
        }
    },
    methods: {
        async setData() {
            if (this.$route.query.token) {
                if (Date.now() > (JSON.parse(atob(this.$route.query.token.split(".")[1])).exp * 1000)) {
                    alert('Session expired')
                    return
                }
            } else {
                alert('Invalid Session')
                return
            }
            
            this.$emit('toggleLoader');

            const candidate = await DataService.getCandidate(this.$route.params.id);
            
            if (candidate) {
                if (this.certifierIsAssessor || this.certifierIsPanel) {
                    if (candidate.submittedDoc) {
                        this.candidate = candidate.submittedDoc;
                    } else {
                        this.candidate = candidate
                    }
                } else if (this.certifierIsExternal) {
                    var payload = this.$route.query.token.split('.')[1]
                    var id = JSON.parse(atob(payload)).id

                    if (candidate.presentStatus == 'Senior Lecturer' || candidate.presentStatus == 'Senior Research Fellow') {
                        for (var i=0; i < candidate.readerExternalAssessors.length; i++) {
                            if (candidate.readerExternalAssessors[i].id == id) {
                                this.candidate = candidate.readerExternalAssessors[i].candidate
                            }
                        }
                    } else if (candidate.presentStatus == 'Reader' || candidate.presentStatus == 'Research Reader') {
                        for (var i=0; i < candidate.profExternalAssessors.length; i++) {
                            if (candidate.profExternalAssessors[i].id == id) {
                                this.candidate = candidate.profExternalAssessors[i].candidate
                            }
                        }
                    }
                } else if (this.certifierIsInternal) {
                    var payload = this.$route.query.token.split('.')[1]
                    var id = JSON.parse(atob(payload)).id

                    if (candidate.presentStatus == 'Senior Lecturer' || candidate.presentStatus == 'Senior Research Fellow') {
                        for (var i=0; i < candidate.readerInternalAssessors.length; i++) {
                            if (candidate.readerInternalAssessors[i].id == id) {
                                this.candidate = candidate.readerInternalAssessors[i].candidate
                            }
                        }
                    } else if (candidate.presentStatus == 'Reader' || candidate.presentStatus == 'Research Reader') {
                        for (var i=0; i < candidate.profInternalAssessors.length; i++) {
                            if (candidate.profInternalAssessors[i].id == id) {
                                this.candidate = candidate.profInternalAssessors[i].candidate
                            }
                        }
                    }
                }
            }

            this.$emit('toggleLoader');
        },
        sumArray(array, sumVar) {
            for (var i = 0; i < array.length; i++) {
                sumVar += array[i].score
            }
            return sumVar
        },
        multiplyArray(array, sumVar) {
            for (var j = 0; j < array.length; j++) {
                sumVar += (array[j].sessionNum * array[j].score)
            }
            return sumVar
        },
        async submitAssessment() {
            this.$emit('toggleLoader');

            var details = {
                candidateId: this.$route.params.id,
                comments: this.comments,
                token: this.$route.query.token,
                approval: this.approval,
                total: this.total,
                /*
                bank: this.bank,
                acctName: this.acctName,
                acctNum: this.acctNum
                */
            }

            const candidate = await DataService.submitAssessment(details);
            
            if (candidate) {
                alert('Assessment submitted successfully')
                this.$router.push({ path: '/' });
            }

            this.$emit('toggleLoader');
        }
    }
}
</script>